import React, { useCallback } from 'react';
import cn from 'classnames';
import { Field } from 'react-final-form';

type Props = {
  name: string;
  editable: boolean;
  placeholder: string;
  onCheckboxChange: Function;
  onRemoveItem: Function;
  bigSize: boolean;
  checkboxValue: boolean;
  innerRef?: {
    current: HTMLInputElement;
  };
};

export default function Input({
  name,
  editable,
  placeholder,
  checkboxValue,
  bigSize,
  onRemoveItem,
  onCheckboxChange,
  innerRef,
}: Props) {
  const handleFocus = useCallback(() => {
    if (!checkboxValue && editable) onCheckboxChange(true);
  }, [checkboxValue, editable, onCheckboxChange]);

  const handleKeyPress = useCallback(
    event => {
      if (event.key === 'Backspace' && !event.target.value) onRemoveItem();
    },
    [onRemoveItem]
  );

  return (
    <Field name={name}>
      {({ input: { onChange, value } }) => (
        <input
          ref={innerRef}
          value={value}
          onKeyDown={handleKeyPress}
          onChange={onChange}
          onFocus={handleFocus}
          placeholder={placeholder}
          readOnly={!editable}
          className={cn('form-control onboarding-checkbox-item-input border-0 shadow-none py-0', {
            'cursor-pointer': !editable,
            'align-self-center': bigSize,
          })}
        />
      )}
    </Field>
  );
}
